import config from 'src/config/config';
import api from 'src/api/interceptor';
import axios from 'axios';

export async function LoginApi(UserData) {
  return axios
    .post(`${config.test_url}api/vehicle-tracking/login/`, UserData)
    .then((res) => {
      const response = res.data;
      if (response) {
        localStorage.setItem('userData', JSON.stringify(response.user_details));
        localStorage.setItem('token', response.token);
        localStorage.setItem('superAdmin', response.super_admin);
        localStorage.setItem('organisationAdmin', response.organisation_admin);
        localStorage.setItem('normalUser', response.normal_user);
        localStorage.setItem('userType', response.user_type);
        localStorage.setItem('userRole', response.user_role);
        localStorage.setItem(
          'showVehicleTrackingCreate',
          response.first_stage_assigned,
        );
      }
      return Promise.resolve(response);
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        // if incorrect credential then return password error
        return Promise.reject(new Error('credentials'));
      }
      if (error.response && error.response.status === 400) {
        return Promise.reject(new Error('subscription'));
      }
      return Promise.reject(error);
    });
}

export async function LogoutApi() {
  localStorage.removeItem('userData');
  localStorage.removeItem('token');
  localStorage.removeItem('superAdmin');
  localStorage.removeItem('organisationAdmin');
  localStorage.removeItem('normalUser');
  localStorage.removeItem('userType');
  localStorage.removeItem('userRole');
  localStorage.removeItem('showVehicleTrackingCreate');
  localStorage.removeItem('createVehicleTrackingLayoutPreference');
  localStorage.removeItem('savedStationActivityColumns');
  localStorage.removeItem('savedAccountListColumns');
  localStorage.removeItem('savedVarianceReportColumns');
  localStorage.removeItem('savedVehicleTrackingReportColumns');
  localStorage.removeItem('stageDashboardDirectionFilters');
  return true;
}

export function getAssignedPermissionsForCurrentUserApi(
  tenantOrganisationId,
  appLabelId,
) {
  return api
    .get(
      `${config.test_url}api/workforce/get-assigned-permissions-for-current-user/?tenant_organisation_id=${tenantOrganisationId}&app_label_id=${appLabelId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function resetPasswordApi(resetPasswordPayload) {
  return api
    .post(`${config.test_url}api/core/reset-password/`, resetPasswordPayload)
    .then((res) => Promise.resolve(res));
}

export function updateProfileDetailsApi(payload) {
  return api
    .post(`${config.test_url}api/core/update-profile-details/`, payload)
    .then((res) => Promise.resolve(res));
}
